import { boolean } from "yargs";
import UserFund from "../../entities/UserFund";
import {
  RESET_USER,
  SET_FIRST_NAME,
  SET_IS_AMIT,
  SET_IS_PENSIONER,
  SET_IS_101_BUTTON_ALLOWED,
  SET_101_Url,
  SET_IS_ONLINE,
  SET_LAST_NAME,
  SET_USER_FUNDS,
  SET_MAP_USER_FUNDS,
  SET_USER_ID,
  SET_HAVE_MESSAGES,
  SET_ID_DATE,
  SET_IS_SUSPEND,
  HAVE_YEAR_REPORTS,
  SET_MIFNE_FUNDS,
  SET_IS_SEND_AGAIN_POSSIBLE,
  SET_IS_SEND_AGAIN_POSSIBLE_DATE,
  SET_PENTION_TYPE_DESC,
  SET_PENSION_TYPE_DESC_HEADER,
  IS_FILE_FOUND,
  SET_IS_ENTERED_FROM_TO_SHOW_FILE,
  SET_PENTION_TYPE_DESC_COUNTER,
  SET_IS_VALID_AND_NOT_MEMEBER,
  setIssueDate,
  SET_ISSUE_DATE
} from "../actions/UserActions";
import SalaryData from "../../entities/SalaryData";
import { SET_SALARY_DATA_REDUX } from "../actions/DashboardActions";

const initialState: UserInitialState = {
  userId: "",
  isOnline: false,
  isFileFound:true,
  isEnteredFromToShowFile: false,
  userFunds: [],
  mapUserFunds: null,
  firstName: "",
  lastName: "",
  isAmit: false,
  haveYearlyReportsred:[],
  isPensioner: false,
  is101ButtonAllowed: false,
  url101: "",
  haveMessages: false,
  idDate: "", // value for only register.
  isSuspend: false,
  isSendAgainPossible: true,
  isSendAgainPossibleDate: new Date(),
  pensionTypeDesc: "",
  salaryDataRedux: [],
  pensionTypeDescHeader: [],
  pensionTypeDescCounter: 0,
  isValidAndNotUser: null,
  issueDate: "",
};

const UserReducer = (state = initialState, action: any) => {
  switch (action.type) {    
    case SET_IS_ENTERED_FROM_TO_SHOW_FILE:
      return {
        ...state,
        isEnteredFromToShowFile: action.payload,
      };  
    case IS_FILE_FOUND:
      return {
        ...state,
        isFileFound: action.payload,
      };    
    case SET_USER_ID:
      return {
        ...state,
        userId: action.payload,
      };
    case SET_IS_ONLINE:
      return {
        ...state,
        isOnline: action.payload,
      };
    case SET_USER_FUNDS:
      return {
        ...state,
        userFunds: action.payload,
      };
    case SET_MAP_USER_FUNDS:
      return {
        ...state,
        mapUserFunds: action.payload,
      };
    case SET_FIRST_NAME:
      return {
        ...state,
        firstName: action.payload,
      };
    case SET_LAST_NAME:
      return {
        ...state,
        lastName: action.payload,
      };
    case SET_IS_AMIT:
      return {
        ...state,
        isAmit: action.payload,
      };
    case SET_IS_PENSIONER:
      return {
        ...state,
        isPensioner: action.payload,
      };
      case SET_IS_101_BUTTON_ALLOWED:
      return {
        ...state,
        is101ButtonAllowed: action.payload,
      };
       case SET_101_Url:
      return {
        ...state,
        url101: action.payload,
      };
    case SET_HAVE_MESSAGES:
      return {
        ...state,
        haveMessages: action.payload,
      };
    case SET_IS_SUSPEND:
      return {
        ...state,
        isSuspend: action.payload,
      };
    case SET_MIFNE_FUNDS:
        return {
          ...state,
          isSuspend: action.payload,
        };
    case HAVE_YEAR_REPORTS:
    return {
      ...state,
      haveYearlyReportsred: action.payload,
    };
    case SET_ID_DATE:
      return {
        ...state,
        idDate: action.payload,
      };
      case SET_ID_DATE:
      return {
        ...state,
        idDate: action.payload,
      };
      case SET_IS_SEND_AGAIN_POSSIBLE:
        return {
          ...state,
          isSendAgainPossible: action.payload,
        };
      case SET_IS_SEND_AGAIN_POSSIBLE_DATE:
        return {
          ...state,
          isSendAgainPossibleDate: action.payload,
        };

        case SET_PENTION_TYPE_DESC:
        return {
          ...state,
          pensionTypeDesc: action.payload,
        };
      
    case RESET_USER:
      return {
        ...initialState,
      };
      case SET_SALARY_DATA_REDUX:{
        return {
          ...state,
          salaryDataRedux: action.payload,
        }
      }
      case SET_PENSION_TYPE_DESC_HEADER:{
        return {
          ...state,
          pensionTypeDescHeader: action.payload,
        }
      }
      case SET_PENTION_TYPE_DESC_COUNTER:{
        return {
          ...state,
          pensionTypeDescCounter: action.payload,
        }
      }
      case SET_IS_VALID_AND_NOT_MEMEBER:{
        return {
          ...state,
          isValidAndNotUser: action.payload,
        }
      }
      case SET_ISSUE_DATE:{
        console.log("sdf");
        
        return {
          ...state,
          issueDate: action.payload,
        }
      }
      
    default:
      return state;
  }
};

export interface UserInitialState {
  userId: string;
  isOnline: boolean;
  isFileFound: boolean;
  isEnteredFromToShowFile: boolean;
  userFunds: UserFund[];
  mapUserFunds:any;
  firstName: string;
  lastName: string;
  isAmit: boolean;
  haveYearlyReportsred:[];
  isPensioner: boolean;
  is101ButtonAllowed: boolean;
  url101: string;
  haveMessages: boolean;
  idDate: string; // only for register
  isSuspend: boolean,
  isSendAgainPossible: boolean,
  isSendAgainPossibleDate: Date,
  pensionTypeDesc: string,
  salaryDataRedux:SalaryData[],
  pensionTypeDescHeader:[],
  pensionTypeDescCounter: number,
  isValidAndNotUser: string | null
  issueDate: Date | string
}

export default UserReducer;